<div>
  <button
    *ngIf="
      currentPanelMember.member.username === currentUser.username ||
      canModifyDiscussion
    "
    class="btn btn-primary btn-icon"
    (click)="credentialEditorModal.show()"
  >
    <i class="icofont icofont-pencil" style="margin: auto"></i>
  </button>

  <!-- Panel-credentials-modal -->
  <credential-editor-modal
    #credentialEditorModal
    [currentUser]="currentUser"
    [discussion]="discussion"
    [currentPanelMember]="currentPanelMember"
    [canModifyDiscussion]="canModifyDiscussion"
    [hideFooter]="true"
  >
  </credential-editor-modal>
  <!-- Panel-credentials-modal -->
</div>
